import { routesByPath } from './AppRouter.hooks';

export const accessRoutes = (path: string, flags: Record<string, unknown>) => {
  if (path === 'new-methodology/:id' && flags?.P40_48670_ENABLE_METHODOLOGY_V2) {
    return routesByPath['v2/new-methodology/:id'];
  }

  if (path === 'organizations' && flags?.P40_59408_ENABLE_ORGANIZATIONS_V2) {
    return routesByPath['v2/organizations'];
  }

  return routesByPath[path];
};
